import React from 'react'

import { DocumentLink } from './DocumentLink'
import {
  TDocument,
  TDocumentCategory,
} from '../../../common/validations/document'

import i18n, { Language } from 'i18n/i18n'

export interface DocumentCategoryProps {
  category: TDocumentCategory
  docs: TDocument[]
}

export const DocumentCategoryInfo: React.FC<DocumentCategoryProps> = ({
  category,
  docs,
}) => {
  const lang = i18n.language as Language

  if (!docs.length) {
    return null
  }

  return (
    <>
      {category && (
        <p className="text-xl min-tablet:text-xl font-medium mb-3 min-tablet:mb-6 mt-14 min-table:mt-14">
          {category.labels[lang]}
        </p>
      )}
      <div className="flex flex-col gap-8">
        {docs.map((document) => (
          <DocumentLink key={document.id} document={document} />
        ))}
      </div>
    </>
  )
}
